export default  [
    {
        id:1,
        label:'Completely irrelevant',
        color:{
            bg:'#A6EED7',
            text:'#40826E'
        }

    },
    {
        id:2,
        label:'Mostly irrelevant',
        color:{
            bg:'#D5CB75',
            text:'#A68F2E'
        }
    },
    {
        id:3,
        label:'Somewhat irrelevant',
        color:{
            bg:'#F7C7C7',
            text:'#A64F4F'
        }
    },
    {
        id:4,
        label:'Slightly irrelevant',
        color:{
            bg:'#F7C7C7',
            text:'#A64F4F'
        },
    },
    {
        id:5,
        label:'Neither relevant nor irrelevant',
        color:{
            bg:'#F7C7C7',
            text:'#A64F4F'
        }
    },
    {
        id:6,
        label:'Slightly relevant',
        color:{
            bg:'#F7C7C7',
            text:'#A64F4F'
        }
    },
    {
        id:7,
        label:'Somewhat relevant',
        color:{
            bg:'#F7C7C7',
            text:'#A64F4F'
        }
    },
    {
        id:8,
        label:'Mostly relevant',
        color:{
            bg:'#FCE3E1',
            text:'#E70909'
        }
    },
    {
        id:9,
        label:'Almost entirely relevant',
        color:{
            bg:'#FCE3E1',
            text:'#E70909'
        }
    },
    {
        id:10,
        label:'Extremely relevant',
        color:{
            bg:'#FCE3E1',
            text:'#E70909'
        }
    }
]